module.exports = __webpack_public_path__ + "img/ninja.c1487a25.png";